var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { hot } from 'react-hot-loader';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import AppRouting from './components/AppRouting';
import { ColorModeScript, CSSReset, ChakraProvider } from '@chakra-ui/react';
import customTheme from './components/customTheme';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
function App() {
    return (_jsxs(ChakraProvider, __assign({ theme: customTheme }, { children: [_jsx(CSSReset, {}), _jsx(ColorModeScript, { initialColorMode: customTheme.config.initialColorMode }), _jsxs(BrowserRouter, { children: [_jsx(Navbar, {}), _jsx(AppRouting, {}), _jsx(Footer, {})] })] })));
}
export default hot(module)(App);
